import dayjs from 'dayjs';

const CUSTOMER_GARAGE_CHOICE_FAILED = 'customer-garage-choice-failed';

export function hasNoInvites(invites) {
  return !invites || invites.length === 0;
}

function parseTags(tags) {
  if (!tags) return [];
  if (Array.isArray(tags)) return tags;

  if (typeof tags !== 'string') return [];

  try {
    const parsedTags = JSON.parse(tags);
    return Array.isArray(parsedTags) ? parsedTags : [];
  } catch (error) {
    return tags.split(',').map((tag) => tag.trim()).filter(Boolean);
  }
}

export function getIsGarageMembership(booking) {
  return parseTags(booking.tags).some((tag) => tag === 'garageMembership');
}

export function isDeclinedAndNotRescheduled(status, proposedChanges) {
  return ['declined'].includes(status) && (!proposedChanges || proposedChanges.length === 0);
}

export function isInviteCreatedWithin24Hours(creationDateTime) {
  const currentDateTime = dayjs();
  const diffInHours = currentDateTime.diff(dayjs(creationDateTime), 'hour');

  return diffInHours < 24;
}

export function shouldShowMembershipTag(booking, invites) {
  const isGarageMembership = getIsGarageMembership(booking);

  if (hasNoInvites(invites) || invites.length > 1) return !!isGarageMembership;

  const { creationDateTime, status, proposedChanges } = invites[0];

  if (
    isGarageMembership &&
    !isDeclinedAndNotRescheduled(status, proposedChanges) &&
    isInviteCreatedWithin24Hours(creationDateTime)
  )
    return true;

  return false;
}

export function getCustomerChoiceFailedNoteContent(booking) {
  return booking.notes.find((note) => note.noteType === CUSTOMER_GARAGE_CHOICE_FAILED)?.content;
}

export function shouldShowCustomerChoiceFailedTag(booking, invites) {
  const hasCustomerGarageChoiceFailedNote = booking.notes.some(
    (note) => note.noteType === CUSTOMER_GARAGE_CHOICE_FAILED
  );
  const hasAcceptedInvite = invites.some((invite) => invite.status === 'accepted');
  return hasCustomerGarageChoiceFailedNote && !hasAcceptedInvite;
}
